export { default } from './ModalCamera';
